module.exports = __webpack_public_path__ + "static/img/clienteleImg.61af83b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/clientele/clienteleImg.png
// module id = 654
// module chunks = 12